(function () {
  'use strict';

  var DILL_HANDLE = 'pickle-juice-original-dill';
  var LEMONADE_HANDLE = 'pickie-pickle-lemonade';
  var syncTimer = null;
  var apiSyncTimer = null;
  var apiSyncInFlight = false;
  var apiSyncQueued = false;
  var pendingAddedHandle = '';
  var revealTimer = null;

  function setVisible(element, visible) {
    if (!element) return;
    if (visible && element.hasAttribute('hidden')) element.removeAttribute('hidden');
    if (!visible && !element.hasAttribute('hidden')) element.setAttribute('hidden', '');
  }

  function applyUpsellState(hasDill, hasLemonade) {
    var containers = document.querySelectorAll('[data-pickie-upsell-container]');

    containers.forEach(function (container) {
      var cards = container.querySelectorAll('[data-pickie-upsell-card]');
      var foundTarget = false;
      cards.forEach(function (card) {
        var handle = card.getAttribute('data-product-handle');
        var shouldShow = (handle === DILL_HANDLE && !hasDill) ||
          (handle === LEMONADE_HANDLE && !hasLemonade);
        setVisible(card, shouldShow);
        if (shouldShow) foundTarget = true;
      });

      setVisible(container, foundTarget);
    });
  }

  function handleFromCartItem(item) {
    if (!item) return '';
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;

    var url = item.url || '';
    var match = url.match(/\/products\/([^?]+)/);
    return match ? match[1] : '';
  }

  function syncCartUpsells() {
    var containers = document.querySelectorAll('[data-pickie-upsell-container]');
    var hasDill = false;
    var hasLemonade = false;

    containers.forEach(function (container) {
      var cart = container.closest('[data-cart]') || document;
      var itemRows = cart.querySelectorAll('[data-items-holder] [data-item][data-product-handle]');

      itemRows.forEach(function (row) {
        var handle = row.getAttribute('data-product-handle');
        if (handle === DILL_HANDLE) hasDill = true;
        if (handle === LEMONADE_HANDLE) hasLemonade = true;
      });
    });

    applyUpsellState(hasDill, hasLemonade);
  }

  function syncCartUpsellsFromApi() {
    if (apiSyncInFlight) {
      apiSyncQueued = true;
      return;
    }

    var root = window.theme && window.theme.routes && window.theme.routes.root
      ? window.theme.routes.root
      : '/';

    apiSyncInFlight = true;
    fetch(root + 'cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart recommendations.');
        return response.json();
      })
      .then(function (cartData) {
        var hasDill = false;
        var hasLemonade = false;

        (cartData.items || []).forEach(function (item) {
          var handle = handleFromCartItem(item);
          if (handle === DILL_HANDLE) hasDill = true;
          if (handle === LEMONADE_HANDLE) hasLemonade = true;
        });

        applyUpsellState(hasDill, hasLemonade);
      })
      .catch(function () {
        syncCartUpsells();
      })
      .then(function () {
        apiSyncInFlight = false;
        if (apiSyncQueued) {
          apiSyncQueued = false;
          syncCartUpsellsFromApi();
        }
      });
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncCartUpsells, 40);
    window.clearTimeout(apiSyncTimer);
  }

  function revealAddedItem() {
    if (!pendingAddedHandle) return false;

    var rows = document.querySelectorAll(
      '.cart-drawer [data-items-holder] [data-item][data-product-handle="' + pendingAddedHandle + '"]'
    );
    var row = rows.length ? rows[rows.length - 1] : null;
    if (!row) return false;

    pendingAddedHandle = '';
    row.classList.add('pickie-r9-cart-item--just-added');
    row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    window.setTimeout(function () {
      row.classList.remove('pickie-r9-cart-item--just-added');
    }, 1800);
    return true;
  }

  function scheduleReveal() {
    window.clearTimeout(revealTimer);
    revealTimer = window.setTimeout(function () {
      revealAddedItem();
    }, 70);
  }

  function openCartDrawer(addedHandle) {
    var cartDrawer = window.cart;

    if (addedHandle) pendingAddedHandle = addedHandle;

    if (cartDrawer && typeof cartDrawer.openCartDrawer === 'function') {
      if (typeof cartDrawer.getCart === 'function') {
        var refresh = cartDrawer.getCart();
        if (refresh && typeof refresh.then === 'function') {
          refresh.then(function () {
            scheduleSync();
            scheduleReveal();
          });
        }
      }
      if (!cartDrawer.cartDrawerIsOpen) cartDrawer.openCartDrawer();
      window.setTimeout(function () {
        scheduleSync();
        scheduleReveal();
      }, 120);
      return;
    }

    var cartToggle = document.querySelector('[data-cart-toggle]');
    if (cartToggle) cartToggle.click();
    window.setTimeout(function () {
      scheduleSync();
      scheduleReveal();
    }, 120);
  }

  function addOppositeFlavor(button) {
    if (typeof window.PICKIE_MINIMAL_ADD === 'function') {
      window.PICKIE_MINIMAL_ADD(button);
      return;
    }
    var card = button.closest('[data-pickie-upsell-card]');
    var targetHandle = button.getAttribute('data-target-handle') ||
      (card ? card.getAttribute('data-product-handle') : '');
    var variantId = Number(button.getAttribute('data-variant-id'));
    if (!variantId || button.disabled) return;

    var originalText = button.textContent;
    var root = window.theme && window.theme.routes && window.theme.routes.root
      ? window.theme.routes.root
      : '/';

    button.disabled = true;
    button.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      pickieBypassProductFormHarden: true,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data && data.description ? data.description : 'Unable to add this flavor.');
          }
          return data;
        });
      })
      .then(function () {
        button.textContent = 'Added ✓';
        // The full cart has no drawer controls; reload its server-rendered totals.
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        openCartDrawer(targetHandle);
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
          scheduleSync();
        }, 900);
      })
      .catch(function (error) {
        button.disabled = false;
        button.textContent = originalText;
        window.alert(error.name === 'TypeError' || error.name === 'SyntaxError'
          ? 'Your connection was interrupted. This flavor may have been added. Please check your cart before trying again.'
          : error.message || 'Unable to add this flavor.');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pickie-cart-upsell]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addOppositeFlavor(button);
  }, true);

  /* Used by the PDP add-to-cart path, which has already rebuilt the drawer from
     the section markup that came back with the add. This reads the rendered
     rows rather than calling /cart.js again, so refreshing the cross-sell costs
     no network at all. */
  window.PICKIE_SYNC_CART_UPSELLS = function (addedHandle) {
    if (addedHandle) pendingAddedHandle = addedHandle;
    scheduleSync();
    scheduleReveal();
  };

  function mount() {
    syncCartUpsells();

    window.PICKIE_OPEN_CART_DRAWER = function () {
      openCartDrawer('');
    };

    var drawer = document.querySelector('.cart-drawer');
    if (!drawer || drawer.__pickieRelease12Observer) return;

    var observer = new MutationObserver(function () {
      scheduleSync();
      scheduleReveal();
    });
    observer.observe(drawer, { childList: true, subtree: true });
    drawer.__pickieRelease12Observer = observer;
  }

  window.PICKIE_OPEN_CART_DRAWER = function () {
    openCartDrawer('');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', mount);
})();
